import React, { useState } from "react";
import "./BottomDock.css";
import finderIcon from "./assets/finder.png";
import launchpadIcon from "./assets/launchpad.png";
import appStoreIcon from "./assets/app_store.png";
import settingsIcon from "./assets/settings.png";
import photosIcon from "./assets/photos.png";
import notionIcon from "./assets/notion.png";
import creativeCloudIcon from "./assets/creative_cloud.png";
import chromeIcon from "./assets/chrome.png";
import vscodeIcon from "./assets/vscode.png";
import dockerIcon from "./assets/docker.png";
import terminalIcon from "./assets/terminal.png";
import slackIcon from "./assets/slack.png";
import spotifyIcon from "./assets/spotify.png";
import mailIcon from "./assets/mail.png";
import notesIcon from "./assets/notes.png";
import remindersIcon from "./assets/reminders.png";
import facetimeIcon from "./assets/facetime.png";
import messagesIcon from "./assets/messages.png";
import mongodbIcon from "./assets/mongodb.png";
import trashIcon from "./assets/trash.png";

const BottomDock = ({ onDockClick }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const dockApps = [
    { icon: finderIcon, name: "Finder", hasNotification: false, isImage: true },
    {
      icon: launchpadIcon,
      name: "Launchpad",
      hasNotification: false,
      isImage: true,
    },
    {
      icon: appStoreIcon,
      name: "App Store",
      hasNotification: false,
      isImage: true,
    },
    {
      icon: settingsIcon,
      name: "System Preferences",
      hasNotification: true,
      count: 2,
      isImage: true,
    },
    { icon: photosIcon, name: "Photos", hasNotification: false, isImage: true },
    {
      icon: mailIcon,
      name: "Mail",
      hasNotification: true,
      isImage: true,
      count: 9,
    },
    {
      icon: facetimeIcon,
      name: "FaceTime",
      hasNotification: false,
      isImage: true,
    },
    {
      icon: messagesIcon,
      name: "Messages",
      hasNotification: true,
      count: 5,
      isImage: true,
    },
    { icon: notesIcon, name: "Notes", hasNotification: false, isImage: true },
    {
      icon: remindersIcon,
      name: "Reminders",
      hasNotification: true,
      count: 3,
      isImage: true,
    },
    { icon: chromeIcon, name: "Chrome", hasNotification: false, isImage: true },
    { icon: notionIcon, name: "Notion", hasNotification: false, isImage: true },
    { icon: slackIcon, name: "Slack", hasNotification: false, isImage: true },
    {
      icon: vscodeIcon,
      name: "Visual Studio Code",
      hasNotification: false,
      isImage: true,
    },
    {
      icon: mongodbIcon,
      name: "MongoDB",
      hasNotification: false,
      isImage: true,
    },
    { icon: dockerIcon, name: "Docker", hasNotification: false, isImage: true },
    {
      icon: terminalIcon,
      name: "Terminal",
      hasNotification: false,
      isImage: true,
    },
    {
      icon: spotifyIcon,
      name: "Spotify",
      hasNotification: false,
      isImage: true,
    },
    {
      icon: creativeCloudIcon,
      name: "Adobe Creative Cloud",
      hasNotification: false,
      isImage: true,
    },
    { icon: trashIcon, name: "Trash", hasNotification: false, isImage: true },
  ];

  return (
    <div className="bottom-dock">
      <div className="dock-container">
        {dockApps.map((app, index) => (
          <div
            key={index}
            className="dock-item"
            onClick={onDockClick}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            {hoveredIndex === index && (
              <div className="dock-tooltip">{app.name}</div>
            )}
            <div className="dock-icon">
              {app.isImage ? (
                <img
                  src={app.icon}
                  alt={app.name}
                  className="dock-icon-image"
                  draggable="false"
                  onContextMenu={(e) => e.preventDefault()}
                />
              ) : (
                app.icon
              )}
              {app.hasNotification && (
                <div className="notification-badge">{app.count}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BottomDock;
